module.exports = __webpack_public_path__ + "static/media/axfood.0fb38c16.jpg";